import React from 'react';
import { App } from '@gin-betting/core';

import './MatchTracker.scss';

interface Props {
    loadScriptStatus: App.FetchStatus;
    styleProps: { width?: string | number; height?: string | number };
}

const MatchTracker: React.FC<Props> = (props: Props) => {
    const { loadScriptStatus, styleProps } = props;

    if (loadScriptStatus !== App.FetchStatus.LOADED) {
        return null;
    }

    return (
        <div
            id="matchTracker"
            styleName="tracker"
            style={{
                ...styleProps,
                height: styleProps.height || '100%',
            }}
        />
    );
};

export default MatchTracker;
